import React, { ReactNode } from 'react';
import '../../scss/components/SingleCheckbox.scss';

interface CheckboxInputProps {
    onChange?:any,
    checked?:boolean,
    name:string,
    disabled?:boolean,
    className?:string,
    wrapperClassName?:string,
    required?:boolean,
    label?:string|ReactNode,
    labelPosition?:string,
    readOnly?:boolean,
    ariaLabel?:string
    toggle?:boolean,
    error?:string,
}

const CheckboxInput = ({
    onChange,
    checked,
    name,
    disabled,
    className,
    wrapperClassName,
    required,
    label,
    labelPosition = 'after',
    readOnly,
    ariaLabel,
    toggle,
    error
}:CheckboxInputProps) => {
    return (
        <div className={`form-group checkbox${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
            <input
                type={`checkbox`}
                name={name}
                id={name}
                checked={checked}
                disabled={disabled}
                onChange={onChange}
                className={`${className}${labelPosition ? ' label-' + labelPosition : ''}${toggle ? ' toggle' : ''}${error ? ' invalid' : ''}`}
                aria-required={required ? 'true' : 'false'}
                readOnly
                aria-label={ariaLabel ? ariaLabel : (typeof label === 'string' ? label + (required ? ' (Erforderlich)' : '') : undefined)}
            />
            { label && (typeof label !== 'string' || label.length > 0) ? (
                <label htmlFor={name}>{label} {required ? '*' : ''}</label>
            ) : <></>}
            { error && (
                <span className='form-error'>{ error }</span>
            ) }
        </div>
    )
}

export default CheckboxInput;